import React, { useState, memo } from "react";
import borderBack from "../../../assets/images/borderBack.png";
import CardLayout from "./CardLayout";
import MainButton from "../../shared/Button";
import { usePaymentInputs } from "react-payment-inputs";
import { number } from "card-validator";
import { useNavigate } from "react-router-dom";
// import { AES, enc, SHA256 } from "crypto-js";
import {
  CardMain,
  Header,
  LinkedButton,
  Maincontant,
  CardFromMain,
  CardDateMain,
  CustomLabel,
  CustomInput,
} from "./styles/CardInformationStyle";
import * as CryptoJS from "crypto-js";
import { ADD_CARD } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
// import Loader from "../../shared/loader";
import { getCardCategory } from "../../../helpers/getCardCategory";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";

const CardInformation = ({ ClickHandler }) => {
  const { user: userInfo = {} } = useSelector((state) => state?.auth);

  const dispatch = useDispatch();

  // const customKey = "74dcbed526edece788e0bc18965dade2";
  // const iv = "1478522589633698";
  const navigate = useNavigate();
  const [cardName, setCardName] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cvc, setCVC] = useState("");
  const [CardType, SetCardType] = useState(null);
  const [error, setError] = useState("");
  const [Loading, setLoading] = useState(false);

  // const [CardLoading, setCardLoading] = useState(false);

  // useEffect(() => {
  //   GetCardInfo();
  // }, []);

  // const GetCardInfo = async () => {
  //   try {
  //     setCardLoading(true);
  //     const resp = await httpRequest.get(ADD_CARD);

  //     if (resp?.status === 200 && resp?.data?.message === "Success") {
  //       if (resp?.data?.data) {
  //         navigate("/profile");
  //       }
  //     }
  //     setCardLoading(false);
  //   } catch (error) {
  //     toast.error(error?.response?.data?.message || "Something went wrong");
  //     setCardLoading(false);
  //   }
  // };

  const { meta, getCardNumberProps, getExpiryDateProps, getCVCProps } =
    usePaymentInputs();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      cardName,
      cardNumber,
      expiryDate,
      cvc,
    };
    if (!cardNumber || !cardName || !expiryDate || !cvc) {
      toast.error("Please fill in all the fields");
      return;
    }
    if (!/^[a-zA-Z\s]*$/.test(cardName)) {
      toast.error("Invalid characters in card name");
      return;
    }
    if (cardName.length < 3 || cardName.length > 50) {
      toast.error("Invalid card name");
      return;
    }
    // console.log("Form data:", formData);
    // navigate("/pending-appproval");
    const stringToEncrypt = JSON.stringify(formData);
    let key = "74dcbed526edece788e0bc18965dade2"; //length 32
    let iv = "1478522589633698";

    // let text = "111222333";
    // let Crypto = CryptoJS.Crypto;
    let cipher = CryptoJS.AES.encrypt(
      stringToEncrypt,
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const EncryptedData = cipher.toString();

    try {
      setLoading(true);
      const resp = await httpRequest.post(ADD_CARD, {
        payment_method: EncryptedData,
      });
      if (resp?.status === 200) {
        toast.success("Card added successfully! ");

        const payment_method = {
          id: resp?.data?.data?.id,
          name: resp?.data?.data?.name,
        };

        const UserData = { ...userInfo, payment_method: payment_method };
        dispatch(loginSuccess(UserData));
        navigate("/profile");
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }

    setCardNumber("");
    setExpiryDate("");
    setCVC("");
    setError("");
    setCardName("");
  };

  const handleCardNumberChange = (e) => {
    const { value } = e.target;
    const maxLength = 19;
    const formattedValue = value.slice(0, maxLength);
    setCardNumber(formattedValue);
    const numberValidation = number(formattedValue);
    if (!numberValidation.isPotentiallyValid) {
      setError("Invalid card number");
      return;
    }
    if (numberValidation.card) {
      const CardsCategory = getCardCategory(formattedValue);
      // SetCardType(numberValidation.card.type);
      SetCardType(CardsCategory);
    } else {
      SetCardType("Invalid");
    }
  };

  return (
    <CardMain>
      {/* {CardLoading && <Loader />} */}
      {/* {!CardLoading && ( */}
      <>
        <Header>
          <LinkedButton onClick={() => ClickHandler(false)}>
            <img src={borderBack} alt="Linkarrow" />
          </LinkedButton>
          <Maincontant>
            <h6>Add Payment Method</h6>
            <p>Provide your Credit/Debit card information</p>
          </Maincontant>
        </Header>
        <CardFromMain>
          {/* form section */}

          <form onSubmit={handleSubmit} autocomplete="off">
            <div className="">
              <CustomLabel>Name On Card</CustomLabel>
              <CustomInput
                type="text"
                name="cardname"
                maxLength={20}
                placeholder="Enter your name"
                value={cardName}
                onChange={(e) => {
                  const input = e.target.value;
                  if (input.length <= 50) {
                    setCardName(input);
                  }
                }}
              />
            </div>
            <div>
              <CustomLabel>Card Number</CustomLabel>
              <CustomInput
                {...getCardNumberProps({
                  onChange: handleCardNumberChange,
                  value: cardNumber,
                })}
                placeholder="Enter your card number"
              />
            </div>
            <CardDateMain>
              <div className="AuthInputMain">
                <CustomLabel>Expiration Date</CustomLabel>
                <CustomInput
                  {...getExpiryDateProps({
                    onChange: (e) => {
                      setExpiryDate(e.target.value);
                    },
                    value: expiryDate,
                  })}
                  placeholder="MM/YY"
                />
              </div>
              <div className="AuthInputMain">
                <CustomLabel>CVC</CustomLabel>
                <CustomInput
                  {...getCVCProps({
                    onChange: (e) => {
                      setCVC(e.target.value);
                    },
                    value: cvc,
                  })}
                  placeholder="cvc"
                />
              </div>
            </CardDateMain>
            {/* {meta.isTouched && meta.error && <span>{meta.error}</span>} */}
            {/* {error && !meta.isTouched && <span>{error}</span>} */}
            <MainButton
              type="submit"
              label="Add Card"
              MT="110"
              isLoading={Loading}
            />
          </form>
          {/* card section */}
          <CardLayout
            CardNumbers={cardNumber}
            cardName={cardName}
            expirationDate={expiryDate}
            cardType={CardType}
          />
        </CardFromMain>
      </>
      {/* )} */}
    </CardMain>
  );
};

export default memo(CardInformation);
